module.exports = __webpack_public_path__ + "img/apple-badge.1c455cc9.svg";